// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__32dUf","header":"MergedInvoice_header__2iBf4"};